export interface IVehiclePaths {
  vehicles: {
    index: string;
    details: {
      index: string;
    };
    add: string;
  };

  jobsheets: {
    index: string;
    details: string;
    add: string;
    cloneRedirect: string;
  };

  smr: {
    index: string;
    details: string;
  };
}

const paths: IVehiclePaths = {
  vehicles: {
    index: '/vehicles',
    details: {
      index: '/vehicles/:id'
    },
    add: '/vehicles/add'
  },

  jobsheets: {
    index: '/vehicles/jobsheets',
    details: '/vehicles/jobsheets/:id',
    cloneRedirect: '/vehicles/jobsheets/clone/:id'
  },

  smr: {
    index: '/vehicles/smr',
    details: '/vehicles/smr/:reg/:type/:id'
  }
};

export default paths;
